$(function () {	
	var marketingPagesize = $('#marketing-pagesize-count').val(),
	    prSegmentListFilterVal = "",
	    prServiceAreaVal = "",
		IsUserAuthenticated = $("#IsUserAuthenticated").val(),
		currentPage = 1,
		clearMarketingFiltersBtn = $("#clearMarketingFilters"),
		marketingSegmentLavel = "",
		marketingServiceLavel = "";

		clearMarketingFiltersBtn.hide();

	var updateFilter = function (selector, facet, paramName) {
		const selected =
			paramName === "ServiceAreaId"
			? prServiceAreaVal
			: prSegmentListFilterVal;

		const $ul = $(selector);
		let html = "";

		if (facet && facet.values) {
			html += `
			<li data-list-value="" class="${!selected ? "active" : ""}">
				${facet.label}
			</li>
			`;

			facet.values.forEach(v => {
			if (!v.count) return;

			const isActive = selected === v.id;

			html += `
				<li data-list-value="${v.id}" class="${isActive ? "active" : ""}">
					${v.name}
					${isActive ? '<a class="clear-filter" href="javascript:void(0);">×</a>' : ""}
				</li>
			`;
			});
		}

		$ul.html(html);
		$ul.closest(".custom-select").removeClass("open").find(".custom-select-list-box").hide();
	};

	function applySelectedValue(selector, selectedValue, defaultText) {
		var $custom = $(selector).closest(".custom-select");
		var $items = $custom.find(".custom-select-list li");

		// Reset state
		if (!selectedValue) {
			$items.removeClass("active").first().addClass("active");
			$custom.find(".custom-select-value").val(defaultText || "");
			$custom.find(".clear-filter").remove();
			return;
		}

		// Apply selection
		$items.each(function () {
			var $li = $(this);
			if ($li.attr("data-list-value") === selectedValue) {
			$li.addClass("active").siblings().removeClass("active");
			$custom.find(".custom-select-value").val(selectedValue.trim());
			}
		});
	}

	function renderMarketingList(data, pageNo, pageSize) {
		var marketingData = "";
		data.results.forEach(item => {
			marketingData += `
				<div class="tile-list thumbnail">
					<div class="tile-list-thumbnail">
						<img 
							src="${item.image && item.image[0] ? item.image[0] : '/-/media/tech/omdia/herobannerwithtile/herobannerwithtileplaceholder.jpeg'}" 
							alt="${item.image && item.image[1] ? item.image[1] : 'placeholder-img'}">
					</div>
					<div class="tile-list-content">
						<label class="action-flag pop-out__trigger ${IsUserAuthenticated === 'true' ? "js-bookmark-article" : "js-pop-out-trigger"}"
							data-pop-out-type="sign-in"
							data-pop-out-align="right"
							data-bookmark-id="${item.itemId}"
							${item.salesforceId ? `data-salesforce-id="${item.salesforceId}"` : `data-salesforce-id`}
							${item.isBookmarked ? "data-is-bookmarked=true" : ""}
							data-info='{
											"event_name": "${item.isBookmarked ? "unbookmark" : "bookmark"}",
											"toolbar_tool": "bookmark",
											"bookmark_title": "${item.title}"}'>

							<svg class="action-flag__icon action-flag__icon--bookmark article-bookmark article-bookmark__bookmarked ${item.isBookmarked ? "is-visible" : null}">
								<use xlink:href="/dist/img/svg-sprite.svg#bookmark_filled"></use>
							</svg>

							<svg class="action-flag__icon action-flag__icon--bookmark article-bookmark ${item.isBookmarked ? null : "is-visible"}">
								<use xlink:href="/dist/img/svg-sprite.svg#bookmark_border"></use>
							</svg>
						</label>
						
						<h3 class="tile-list-title"><a href="${item.url}">${item.title}</a></h3>
						<div class="tile-list-metas">
							<span>${item.searchDate.toString()}</span>
						</div>
						<p>${item.summary}</p>
						<a href="${item.url}" target="_blank" class="cta cta-large cta-secondary">Read more</a>
					</div>
				</div>`;
		});
		
		$("#marketingDataFromFrontend").html(marketingData);
		$("#marketingPaginationFrontend").pagination({
			dataTotalLength: data.totalResults,
			currentPageItem: pageNo,
			dataPerPage: pageSize
		});
		// initiate signin popup and bookmark function
		window.indexPopOuts();
		window.indexBookmarks();
	}
	
	var fetchMarketingData = function(pageNo, pageSize){		
		$("#marketingPaginationBackend").hide();
		$("#marketingDataFromBackend").hide();
		var segmentFacet = null;
		var serviceFacet = null;
		
        $.get("/api/marketingpage/getmarketingpages", {
        // $.get("/api-json/marketlist-data.json", {
			"pId": "bfc4fa2c-23f4-45d6-83f6-917b93d2360f",
            "page": pageNo,
            "perPage": pageSize,
			"SegmentId": prSegmentListFilterVal,
			"ServiceAreaId": prServiceAreaVal
        }, function (respone) {

			if (respone && respone.facets) {
				segmentFacet = respone.facets.find(f => f.id === "segments");
				serviceFacet  = respone.facets.find(f => f.id === "topics");

				marketingSegmentLavel = segmentFacet ? segmentFacet.label : "";
				marketingServiceLavel = serviceFacet ? serviceFacet.label : "";
			}

			// if (respone && respone.facets) {
			// 	segmentFacet = respone.facets.find(f => f.id === "segments");
			// 	serviceFacet  = respone.facets.find(f => f.id === "topics");

			// 	marketingSegmentLavel = segmentFacet ? segmentFacet.label : "";
			// 	marketingServiceLavel = serviceFacet ? serviceFacet.label : "";
			// }

			// ---- NEW : Update dropdown options ----
			updateFilter("#prSegmentListFilter .custom-select-list", segmentFacet, "SegmentID");
			updateFilter("#prServiceAreaFilter .custom-select-list", serviceFacet, "ServiceAreaId");

			applySelectedValue("#prSegmentListFilter .custom-select-list", prSegmentListFilterVal, marketingSegmentLavel);
            applySelectedValue("#prServiceAreaFilter .custom-select-list", prServiceAreaVal, marketingServiceLavel);

            // ------------------ MARKETING LIST RENDER -------------------------
            renderMarketingList(respone, pageNo, pageSize);
        });
    }
	
	var updateHashParam = function(key, value){
		const params = new URLSearchParams(window.location.search);

		// SET or DELETE
		if (value) {
			params.set(key, value);
		} else {
			params.delete(key);
		}

		// SPECIAL CASE: page
		if (key === "page" && (!value || value < 2)) {
			params.delete("page");
		}

		const query = params.toString();
		const newUrl =
			window.location.protocol +
			"//" +
			window.location.host +
			window.location.pathname +
			(query ? "?" + query : "");

		window.history.pushState({ path: newUrl }, "", newUrl);
	}

	function syncFilterState({value, filterSelector, valueSetter, defaultLabel }) {
		if (typeof value === "undefined") return;

		// Update JS variable
		valueSetter(value);

		// Update UI
		const $filter = $(filterSelector);
		const $items = $filter.find(".custom-select-list li");

		if (value) {
			const $matched = $items.filter(function () {
				return $(this).attr("data-list-value") === value;
			});

			if ($matched.length) {
				$matched.addClass("active").siblings().removeClass("active");
				$filter.find("input").val($matched.text().trim());
			}
		} else {
			$items.removeClass("active").first().addClass("active");
			$filter.find(".custom-select-value").val(defaultLabel);
		}

		// Show / hide Clear button
		if (prServiceAreaVal || prSegmentListFilterVal) {
			clearMarketingFiltersBtn.show();
		} else {
			clearMarketingFiltersBtn.hide();
		}
	}
		
	var hashParam = new URLSearchParams(window.location.search);
	if(hashParam && marketingPagesize){
		if(hashParam.get("SegmentID")){
			prSegmentListFilterVal = hashParam.get("SegmentID");
			
			$("#prSegmentListFilter .custom-select-list li").each(function(){
				if($(this).attr('data-list-value') === hashParam.get("SegmentID")){
					$(this).addClass("active").siblings().removeClass("active");
					$("#prSegmentListFilter input").val($(this).text());
				}
			})
		}
		if(hashParam.get("ServiceAreaId")){
			prServiceAreaVal = hashParam.get("ServiceAreaId");
			
			$("#prServiceAreaFilter .custom-select-list li").each(function(){
				if($(this).attr('data-list-value') === hashParam.get("ServiceAreaId")){
					$(this).addClass("active").siblings().removeClass("active");
					$("#prServiceAreaFilter input").val($(this).text());
				}
			})
		}

		if (prServiceAreaVal || prSegmentListFilterVal) {
			clearMarketingFiltersBtn.show();
		}
	}
	
	if(marketingPagesize) {
		if(hashParam.get("page")){
			fetchMarketingData(hashParam.get("page"), marketingPagesize);
			$('link[rel="canonical"]').attr('href', window.location);
		} else {
			fetchMarketingData(1, marketingPagesize);
		}
	}
	
	$("#marketingPaginationFrontend").on('click', "li", function(e){
		e.preventDefault();
		var pageIndex = $(this).find("a").attr("data-index");
		currentPage = pageIndex;
		updateHashParam("page", pageIndex);
		fetchMarketingData(pageIndex, marketingPagesize);
		$('link[rel="canonical"]').attr('href', window.location);
	});

	$("#prSegmentListFilter").on('click', '.custom-select-list li', function () {
		syncFilterState({
			value: $(this).attr("data-list-value"),
			filterSelector: "#prSegmentListFilter",
			valueSetter: (val) => (prSegmentListFilterVal = val),
			defaultLabel: marketingSegmentLavel
		});
		
		fetchMarketingData(1, marketingPagesize);
		updateHashParam("SegmentID", prSegmentListFilterVal);
		updateHashParam('page', "");
		$("#marketingPaginationFrontend").pagination({
			currentPageItem: 1,
		});
	});

	$("#prServiceAreaFilter").on("click", ".custom-select-list li", function (e) {
		syncFilterState({
			value: $(this).attr("data-list-value"),
			filterSelector: "#prServiceAreaFilter",
			valueSetter: (val) => (prServiceAreaVal = val),
			defaultLabel: marketingServiceLavel
		});

		fetchMarketingData(1, marketingPagesize);
		updateHashParam("ServiceAreaId", prServiceAreaVal);
		updateHashParam("page", "");
		$("#marketingPaginationFrontend").pagination({
			currentPageItem: 1,
		});
	});

	clearMarketingFiltersBtn.on("click", function () {
		syncFilterState({
			value: "",
			filterSelector: "#prSegmentListFilter",
			valueSetter: (val) => (prSegmentListFilterVal = val),
			defaultLabel: marketingSegmentLavel
		});

		syncFilterState({
			value: "",
			filterSelector: "#prServiceAreaFilter",
			valueSetter: (val) => (prServiceAreaVal = val),
			defaultLabel: marketingServiceLavel
		});

		// Clear URL params
		updateHashParam("SegmentID", "");
		updateHashParam("ServiceAreaId", "");
		updateHashParam("page", "");

		// Reload data
		fetchMarketingData(1, marketingPagesize);
		$("#marketingPaginationFrontend").pagination({
			currentPageItem: 1
		});
	});

	$(document).on("click", ".marketing-list-filter-item .custom-select .clear-filter", function (e) {
		e.preventDefault();
		e.stopPropagation();

		const $li = $(this).closest("li");
		const $filter = $li.closest(".custom-select");

		// Identify which dropdown
		if ($filter.is("#prSegmentListFilter")) {
			prSegmentListFilterVal = "";
			updateHashParam("SegmentID", "");
		} else if ($filter.is("#prServiceAreaFilter")) {
			prServiceAreaVal = "";
			updateHashParam("ServiceAreaId", "");
		}

		// Reset UI
		$filter.find(".custom-select-list li")
			.removeClass("active")
			.first()
			.addClass("active");

		$filter.find(".custom-select-value").val(
			$filter.is("#prSegmentListFilter") ? marketingSegmentLavel : marketingServiceLavel
		);

		// Page reset
		updateHashParam("page", "");

		// Reload
		fetchMarketingData(1, marketingPagesize);
		$("#marketingPaginationFrontend").pagination({ currentPageItem: 1 });

		// Toggle global clear
		if (prSegmentListFilterVal || prServiceAreaVal) {
			clearMarketingFiltersBtn.show();
		} else {
			clearMarketingFiltersBtn.hide();
		}
	});

	var pressFeedUrl = $("#pressFeedUrl").val();
	$("#pressFeedData").click(function(){
		var url;
		if(prSegmentListFilterVal && prServiceAreaVal){
			url = pressFeedUrl + "?page=" + currentPage + "&perPage=" + marketingPagesize + "&SegmentId=" + prSegmentListFilterVal + "&ServiceAreaId=" + prServiceAreaVal;
		}else if(prSegmentListFilterVal){
			url = pressFeedUrl + "?page=" + currentPage + "&perPage=" + marketingPagesize + "&SegmentId=" + prSegmentListFilterVal;
		}else if(prServiceAreaVal){
			url = pressFeedUrl + "?page=" + currentPage + "&perPage=" + marketingPagesize + "&ServiceAreaId=" + prServiceAreaVal;
		}
		else{
			url = pressFeedUrl + "?page=" + currentPage + "&perPage=" + marketingPagesize;
		}
		window.open(url, '_blank');
	});
	
    $.fn.pagination = function (options) {		
		var _this = this,
			defaults = {
				dataPerPage: 10,
				populatePageCount: 5,
				startPageFrom: 1,
			},
			settings = $.extend({}, defaults, options),
			firstPageIndex = 1,
			initPageIndex = settings.startPageFrom,
			lastPageIndex = settings.populatePageCount,
			pageIncrement,
			activePageIndex = 1,
			totalPageCount = "",
			currentPageItem = settings.currentPageItem;
			
			
		if(this.length > 1){
			this.each(function(){ $(this).pagination(options) });
			return this;
		}
	
		this.populateData = function(){
			totalPageCount = Math.ceil(settings.dataTotalLength / settings.dataPerPage);
			var paginationItem = "";
				
			if(initPageIndex != firstPageIndex){
				paginationItem += `<li>
									<a href="#?page=${firstPageIndex}" data-index="${firstPageIndex}" title="Page ${firstPageIndex}">First</a>
								   </li>
								   <li>...</li>`;
			}
			
			for (var i = initPageIndex; i <= totalPageCount; i++) {
				if(i <= lastPageIndex){
					if(activePageIndex && activePageIndex == i){
						paginationItem += `<li class="active">
											<a href="#?page=${i}" data-index="${i}" title="Page ${i}">${i}</a>
										  </li>`;
					}else{					
						paginationItem += `<li>
											<a href="#?page=${i}" data-index="${i}" title="Page ${i}">${i}</a>
										  </li>`;
					}
				}
			}
			
			if(totalPageCount > lastPageIndex){
				paginationItem += `<li>...</li>`
				
				if(totalPageCount == activePageIndex){
					paginationItem += `<li class"active">
										<a href="#?page=${totalPageCount}" data-index="${totalPageCount}" title="Page ${totalPageCount}">Last</a>
									  </li>`;
				}else {
					paginationItem += `<li>
										<a href="#?page=${totalPageCount}" data-index="${totalPageCount}" title="Page ${totalPageCount}">Last</a>
									  </li>`;
				}
			}
			
			if (totalPageCount <= firstPageIndex) {
				paginationItem = "";
			}			
			this.html(paginationItem);	
		}
		
		this.initialize = function(){
			_this.populateData();
				
			if(currentPageItem){
				activePageIndex = currentPageItem;
			}

			if (currentPageItem && currentPageItem > 2 && currentPageItem <= totalPageCount - 2) {
				initPageIndex = Number(currentPageItem) - 2;
				lastPageIndex = Number(currentPageItem) + 2;
			}
			if (currentPageItem && currentPageItem <= 2) {
				initPageIndex = settings.startPageFrom,
				lastPageIndex = settings.populatePageCount
			}
			if(totalPageCount > 5){
				if (currentPageItem && currentPageItem >= totalPageCount - 2) {
					initPageIndex = totalPageCount - 4;
					lastPageIndex = totalPageCount;
				}
			}
			_this.populateData();
		};
		this.initialize();		
			
		$(_this).on('click', "li", function(e){
			e.preventDefault();
			//e.stopPropagation();
			currentPageItem = $(this).find("a").attr("data-index");
			_this.initialize();
		});
	};
});